import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY_LIGHT} from 'ui-library/Colors';

// TODO BNCH-120993: Move this component to ui-library and update components that use it
export function Table({
  children,
  dataTestAttrs,
}: {
  children: ReactNode;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div className={css(styles.table)} {...getTestProps(dataTestAttrs)}>
      {children}
    </div>
  );
}

export function Header({children, className}: {children: ReactNode; className?: string}): JSX.Element {
  return <div className={classNames('simpleDivTable-header', className)}>{children}</div>;
}

export function HeaderCell({children, className}: {children: ReactNode; className?: string}): JSX.Element {
  return (
    <div className={classNames('simpleDivTable-headerCell', css(styles.headerCell), className)}>
      {children}
    </div>
  );
}

export function Row({
  children,
  isBeingEdited,
  className,
  onClick,
  dataTestAttrs,
}: {
  children: ReactNode;
  isBeingEdited?: boolean;
  className?: string;
  onClick?: () => void;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div
      className={classNames(
        'simpleDivTable-row',
        isBeingEdited ? 'is-beingEdited' : undefined,
        className,
        css(styles.row)
      )}
      onClick={onClick ?? undefined}
      {...getTestProps(dataTestAttrs)}
    >
      {children}
    </div>
  );
}

export function Cell({children, className}: {children: ReactNode; className?: string}): JSX.Element {
  return <div className={classNames('simpleDivTable-cell', css(styles.cell), className)}>{children}</div>;
}

export function EmptyCell({children}: {children: ReactNode}): JSX.Element {
  return <div className={css(styles.emptyCell)}>{children}</div>;
}

const styles = StyleSheet.create({
  table: {
    width: '100%',
    border: 1,
    borderStyle: 'solid',
    borderColor: GRAY_LIGHT,
    borderRadius: 4,
  },
  headerCell: {
    paddingRight: '14px',
    ':last-child': {
      paddingRight: 0,
    },
    display: 'flex',
  },
  cell: {
    paddingRight: '14px',
    wordWrap: 'break-word',
    ':last-child': {
      paddingRight: 0,
    },
    lineHeight: '28px',
  },
  row: {
    cursor: 'pointer',
  },
  emptyCell: {
    width: '100%',
    lineHeight: '28px',
  },
});
